module.exports = __webpack_public_path__ + "img/banker_bmpm.gm.ae7c35e.png";